/**
 * UserSelector - Reusable component for selecting users as issue owners.
 */

import { Select, Spin } from 'antd';
import { useEffect, useState } from 'react';
import type { UserBrief } from '@/types';
import apiClient from '@/api/client';

interface UserSelectorProps {
  value?: number | null;
  onChange?: (value: number | null) => void;
  placeholder?: string;
  allowClear?: boolean;
  loading?: boolean;
}

const UserSelector: React.FC<UserSelectorProps> = ({
  value,
  onChange,
  placeholder = '选择负责人',
  allowClear = true,
}) => {
  const [users, setUsers] = useState<UserBrief[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        const response = await apiClient.get<{ results: UserBrief[] }>('/auth/users/');
        setUsers(response.data.results || []);
      } catch (err) {
        console.error('Failed to fetch users:', err);
      } finally {
        setLoading(false);
      }
    };
    fetchUsers();
  }, []);

  return (
    <Select
      showSearch
      allowClear={allowClear}
      placeholder={placeholder}
      value={value || undefined}
      onChange={onChange}
      loading={loading}
      notFoundContent={loading ? <Spin size="small" /> : '无用户'}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      options={users.map((user) => ({
        value: user.id,
        label: user.display_name || user.username,
      }))}
    />
  );
};

export default UserSelector;
